import { render, staticRenderFns } from "./MarkdownTextArea.vue?vue&type=template&id=5f6219ba&scoped=true&"
import script from "./MarkdownTextArea.vue?vue&type=script&lang=js&"
export * from "./MarkdownTextArea.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownTextArea.vue?vue&type=style&index=0&id=5f6219ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6219ba",
  null
  
)

export default component.exports